import React from "react";
import { observer } from "mobx-react";
import Article from "./Article";
import loadingIcon from "../../../Assets/loading.gif";

const Articles = observer(
  ({
    loading,
    articles,
    trackingId,
    addArticleToPlaylist,
    selectArticle,
    playingArticleId,
  }) => (
    <div className="article-container">
      {loading ? (
        <div className="center-static">
          <img src={loadingIcon} style={{ height: 50, textAlign: "center" }} />
        </div>
      ) : articles.length > 0 ? (
        articles.map((article) => (
          <Article
            key={article.article_id}
            {...{
              article,
              trackingId,
              addArticleToPlaylist,
              selectArticle,
              isActive: article.article_id === playingArticleId,
            }}
          />
        ))
      ) : (
        <div>No results found</div>
      )}
    </div>
  )
);

export default Articles;
